import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Intro from '@app/layout/Intro.tsx';
import CamsSettings from '@app/pages/cams/CamsSettings.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const CamsSettingsPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  return (
    <>
      <ResponsiveLayout
        title={tr(`CamsSettingsPage.title`, `Nastavení kamer`)}
        oneOfPermission={[PermissionTypesEnum.PERMISSION_CAM_ENTRYLOG, PermissionTypesEnum.PERMISSION_CAM_SETTINGS, PermissionTypesEnum.PERMISSION_CAM_SETTINGS_REGISTERED_CAMS]}
      >
        <CamsSettings />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(CamsSettingsPage, {
  onRedirecting: () => <Intro />,
});
